import CareerLandingCover from "@components/pages/career/career-landing-cover"
import CareerLandingLifeAt from "@components/pages/career/career-landing-life-at"
import CareerLandingList from "@components/pages/career/career-landing-list"
import { fetchAPI } from "lib/api"
import { Q_CAREER_PAGE } from "lib/query"
import { metaDesc } from "src/helper/meta-desc"
import { translations } from "src/helper/translations"
import { extractMeta } from "src/mixins"

function CareerPage({ data, lifeAtList, locale, listJobs, listJobLocations }) {
  const pageData = data?.meta
  const cover = extractMeta(pageData, "hero")
  const lifeAt = extractMeta(pageData, "life_at_cinema")
  const listTitle = extractMeta(pageData, "job_listing")
  return (
    <>
      <CareerLandingCover data={cover} locale={locale} />
      {/* <CareerLandingLifeAt
        data={{ ...lifeAt, list: lifeAtList?.data }}
        locale={locale}
      /> */}
      <CareerLandingList
        data={{
          ...listTitle,
          list: listJobs?.data,
          pagination: listJobs?.paginatorInfo,
        }}
        listJobLocations={listJobLocations}
        locale={locale}
      />
    </>
  )
}
export default CareerPage

export async function getServerSideProps(ctx) {
  const { locale } = ctx
  try {
    const { data, lifeAtList, listJobs, listJobLocations } = await fetchAPI(
      Q_CAREER_PAGE,
      { variables: { slug: "job" } }
    )
    if (data && lifeAtList && listJobs && listJobLocations) {
      return {
        props: {
          seo: {
            title: translations[`career_${locale}`],
            description: metaDesc[`career_${locale}`],
          },
          page: "career-page",
          data,
          lifeAtList,
          locale,
          listJobs,
          listJobLocations,
        },
      }
    }
    return { notFound: true }
  } catch (error) {
    return { notFound: true }
  }
}
